import { Component, OnInit, signal, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NavbarComponent } from '../navbar.component/navbar.component';
import { FooterComponent } from '../footer.component/footer.component';
import { ProjectCardComponent } from '../project-card.component/project-card.component';

import { Project } from 'src/app/dto';
import { ProjectsService } from 'src/app/service/projects.service';
import { RouterModule } from "@angular/router";

@Component({
  selector: 'app-projects',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ProjectCardComponent,
    RouterModule
],
  templateUrl: './projects.component.html'
})
export class ProjectsComponent implements OnInit {
  // Verileri Signal olarak tanımlayın
  projects = signal<Project[]>([]);
  search = signal<string>('');
  isLoading = signal<boolean>(true);

  // Computed signal: projects veya search değiştikçe otomatik güncellenir
  filteredProjects = computed(() => {
    const q = this.search().toLowerCase().trim();
    const allProjects = this.projects();
    
    if (!q) return allProjects;
    var data = allProjects.filter(p =>
      p.title.toLowerCase().includes(q) ||
      p.summary.toLowerCase().includes(q) ||
      p.tags.some(t => t.toLowerCase().includes(q))
    );
    return data;
  });

  constructor(private projectsService: ProjectsService) { }

  ngOnInit(): void {
    this.projectsService.getProjects().subscribe(data => {
      this.projects.set(data ?? []); // Signal değerini ata
      this.isLoading.set(false);
    });
  }
}